import React, {useMemo} from 'react';
import {Box, Stack, Typography} from '@mui/material';
import {t} from 'i18next';
import ActionMenuWrapper from '../../../../components/action-menu/action-menu-wrapper/ActionMenuWrapper';
import {CustomMenuItem} from '../../../../components/common/arr-menu/ArrMenu';
import {SourceTypeCode} from '../../../../shared/constants';

interface ICommunicationActions {
  exchangeDocs: {
    totalExchangeDocs: number;
    filtersDomains: number;
    filtersEmailsAddress: number;
    nonEmailDocs: number;
  };
  showBy: string | number | null;
  actionMenuItems?: CustomMenuItem[];
  sourceDetails?: {[key: string]: any};
  getDoActionData?: (data: {
    operationType?: string;
    sourceDetails?: {[key: string]: any};
  }) => {selectedList?: object; destinationList?: object};
  getSourceDetails?: (
    sourceDetails: {[key: string]: any},
    forAPI?: string
  ) => {[key: string]: any};
  showToastFromParent?: (config: any) => void;
  onActionPick?: (
    action: CustomMenuItem,
    callBackForDoc?: (docId: string, source: string) => void
  ) => void;
  validateBeforeBulkAction?: () => boolean;
  isMenuDisabled?: boolean;
}

const CommunicationActions = ({
  exchangeDocs,
  showBy,
  actionMenuItems = [],
  sourceDetails,
  getDoActionData,
  getSourceDetails,
  showToastFromParent,
  onActionPick,
  isMenuDisabled = false,
}: ICommunicationActions) => {
  const {
    totalExchangeDocs = 0,
    filtersDomains = 0,
    filtersEmailsAddress = 0,
    nonEmailDocs = 0,
  } = exchangeDocs || {};

  // Check if sourceDetails is valid (not empty/null)
  const hasValidSourceDetails = useMemo(() => {
    return sourceDetails && Object.keys(sourceDetails).length > 0;
  }, [sourceDetails]);

  // Provide safe sourceDetails - always provide an object (empty if invalid)
  const safeSourceDetails = useMemo(() => {
    return hasValidSourceDetails ? sourceDetails : {};
  }, [hasValidSourceDetails, sourceDetails]);

  return (
    <Box className={'action-area'}>
      <Stack flex={1}>
        <Typography
          className={'typo-text subhead3_size text-inverse-heading'}
          data-testid={`communication-actions-actions-header`}
        >
          {t('reports.communicationExplorer.actionsHeader', {
            totalExchangeDocs,
            filters:
              showBy === 'Emails' ? filtersEmailsAddress : filtersDomains,
            filterBy:
              showBy === 'Emails'
                ? t('reports.communicationExplorer.showByEmails')
                : t('reports.communicationExplorer.showByDomains'),
          })}
        </Typography>
        <Typography
          className={'typo-text body3_size text-inverse-body'}
          data-testid={`communication-actions-note`}
        >
          {`Note: In your selected source(s), there are ${nonEmailDocs} non-email documents not reflected in this visualization`}
        </Typography>
      </Stack>
      <Stack>
        <ActionMenuWrapper
          actions={actionMenuItems}
          sourceType={SourceTypeCode.COMMUNICATIONMAP}
          sourceTypeContext="COMMNOC"
          sourceDetails={safeSourceDetails}
          getDoActionData={getDoActionData}
          getSourceDetails={getSourceDetails}
          showToastFromParent={showToastFromParent}
          onActionPick={onActionPick}
          isDisabled={isMenuDisabled}
          size="medium"
          subMenuDirection="left"
          direction="bottom"
          dataTestId="communication-actions-menu"
        />
      </Stack>
    </Box>
  );
};

export default CommunicationActions;
